/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DureeDto } from './DureeDto';
import {
    DureeDtoFromJSON,
    DureeDtoFromJSONTyped,
    DureeDtoToJSON,
    DureeDtoToJSONTyped,
} from './DureeDto';
import type { TarifDto } from './TarifDto';
import {
    TarifDtoFromJSON,
    TarifDtoFromJSONTyped,
    TarifDtoToJSON,
    TarifDtoToJSONTyped,
} from './TarifDto';
import type { TypeBorne } from './TypeBorne';
import {
    TypeBorneFromJSON,
    TypeBorneFromJSONTyped,
    TypeBorneToJSON,
    TypeBorneToJSONTyped,
} from './TypeBorne';

/**
 * Franchise ou plafond d'une garantie. Même forme en lecture et en écriture.
 * @export
 * @interface BorneDto
 */
export interface BorneDto {
    /**
     * 
     * @type {string}
     * @memberof BorneDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BorneDto
     */
    designation?: string | null;
    /**
     * 
     * @type {TarifDto}
     * @memberof BorneDto
     */
    tarification?: TarifDto;
    /**
     * 
     * @type {TypeBorne}
     * @memberof BorneDto
     */
    type?: TypeBorne;
    /**
     * 
     * @type {number}
     * @memberof BorneDto
     */
    valeurMinimale?: number;
    /**
     * 
     * @type {number}
     * @memberof BorneDto
     */
    valeurMaximale?: number;
    /**
     * 
     * @type {number}
     * @memberof BorneDto
     */
    valeurDefaut?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BorneDto
     */
    valeurs?: Array<number>;
    /**
     * 
     * @type {DureeDto}
     * @memberof BorneDto
     */
    duree?: DureeDto;
}



/**
 * Check if a given object implements the BorneDto interface.
 */
export function instanceOfBorneDto(value: object): value is BorneDto {
    return true;
}

export function BorneDtoFromJSON(json: any): BorneDto {
    return BorneDtoFromJSONTyped(json, false);
}

export function BorneDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorneDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'tarification': json['tarification'] == null ? undefined : TarifDtoFromJSON(json['tarification']),
        'type': json['type'] == null ? undefined : TypeBorneFromJSON(json['type']),
        'valeurMinimale': json['valeurMinimale'] == null ? undefined : json['valeurMinimale'],
        'valeurMaximale': json['valeurMaximale'] == null ? undefined : json['valeurMaximale'],
        'valeurDefaut': json['valeurDefaut'] == null ? undefined : json['valeurDefaut'],
        'valeurs': json['valeurs'] == null ? undefined : json['valeurs'],
        'duree': json['duree'] == null ? undefined : DureeDtoFromJSON(json['duree']),
    };
}

export function BorneDtoToJSON(json: any): BorneDto {
    return BorneDtoToJSONTyped(json, false);
}

export function BorneDtoToJSONTyped(value?: BorneDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'designation': value['designation'],
        'tarification': TarifDtoToJSON(value['tarification']),
        'type': TypeBorneToJSON(value['type']),
        'valeurMinimale': value['valeurMinimale'],
        'valeurMaximale': value['valeurMaximale'],
        'valeurDefaut': value['valeurDefaut'],
        'valeurs': value['valeurs'],
        'duree': DureeDtoToJSON(value['duree']),
    };
}

